import type { JSX } from 'react';

import { useNotificationCenterContext } from './NotificationCenterLayout';
import CreateAlertsSection from './rules/CreateAlertsSection';

const NotificationCenterRulesPage = (): JSX.Element => {
  const { masterProject } = useNotificationCenterContext();

  return <CreateAlertsSection key={masterProject.id} projectId={masterProject.id} />;
};

export default NotificationCenterRulesPage;
